import React, { useState, useEffect } from "react";
import { signOut } from "aws-amplify/auth";
import { useAuth } from "../context/AuthProvider";
import API from "../service/API";
import { modal } from "../modal/ModalService";
import { useLang } from "../context/LangProvider";

const REASON_OPTIONS = [
  {
    label: "원하는 상품이 없어요.",
    value: "item",
  },
  {
    label: "과도한 쇼핑을 자제하고 싶어요.",
    value: "expense",
  },
  {
    label: "쿠폰/포인트 등의 혜택이 너무 적어요.",
    value: "benefit",
  },
  {
    label: "다른 계정으로 가입하고 싶어요.",
    value: "change",
  },
  {
    label: "직접입력",
    value: "custom",
  },
];

const StepRender = React.memo(
  ({
    step,
    reason,
    setReason,
    customReason,
    setCustomReason,
    onNext,
    onPrev,
    busy,
    userInfo,
    agree,
    setAgree,
    i18n,
  }) => {
    switch (step) {
      case 1:
        return (
          <>
            <div className="h5">{i18n("dropout.step1.title")}</div>

            <fieldset className="radio-group">
              {REASON_OPTIONS.map((r) => (
                <label key={r.value} className="radio-item">
                  <input
                    type="radio"
                    name="reason"
                    value={r.value}
                    checked={reason === r.value}
                    onChange={() => setReason(r.value)}
                  />
                  <span className="radio-item__label">
                    {i18n(`dropout.reason.${r.value}`)}
                  </span>
                </label>
              ))}

              {reason === "custom" && (
                <div className="radio-item__custom">
                  <textarea
                    value={customReason}
                    onChange={(e) =>
                      setCustomReason(e.target.value.slice(0, 200))
                    }
                    rows={3}
                    placeholder={i18n("dropout.reason.custom.placeholder")}
                    aria-label={i18n("dropout.reason.custom.aria")}
                  />
                  <div className="radio-item__count">
                    {customReason.length}/{200}
                  </div>
                </div>
              )}
            </fieldset>

            <button
              onClick={onNext}
              disabled={!reason || (reason === "custom" && !customReason)}
              aria-disabled={!reason || (reason === "custom" && !customReason)}
              className="login__btn login__btn--primary"
            >
              {i18n("common.next")}
            </button>
          </>
        );

      case 2:
        return (
          <>
            <div className="h5">{i18n("dropout.step2.title")}</div>

            <div className="benefit-list">
              <div className="benefit-card">
                <img
                  alt={i18n("dropout.benefit.iconAlt")}
                  className="icon"
                  src={require("../img/icon/coupon.png")}
                />
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <div className="h7 brownDark70-color">
                    {i18n("dropout.benefit.coupon.line1")}
                  </div>
                  <div className="h7 bold">
                    {i18n("dropout.benefit.coupon.line2")}
                  </div>
                </div>
                <div className="h7 bold" style={{ textAlign: "right" }}>
                  {userInfo.coupon}
                </div>
              </div>

              <div className="benefit-card">
                <img
                  alt={i18n("dropout.benefit.iconAlt")}
                  className="icon"
                  src={require("../img/icon/coupon.png")}
                />
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <div className="h7 brownDark70-color">
                    {i18n("dropout.benefit.point.line1")}
                  </div>
                  <div className="h7 bold">
                    {i18n("dropout.benefit.point.line2")}
                  </div>
                </div>
                <div className="h7 bold" style={{ textAlign: "right" }}>
                  {userInfo.point}
                </div>
              </div>
            </div>

            <div className="flex-center" style={{ gap: "15px" }}>
              <button
                onClick={onPrev}
                className="login__btn login__btn--outline"
              >
                {i18n("common.prev")}
              </button>
              <button
                onClick={onNext}
                className="login__btn login__btn--primary"
              >
                {i18n("common.next")}
              </button>
            </div>
          </>
        );

      case 3:
        return (
          <>
            <div className="h5">{i18n("dropout.step3.title")}</div>

            <div style={{ marginTop: "50px" }}>
              <div className="h5 bold">{i18n("dropout.notice.title")}</div>

              <div className="dropout-notice">
                <div className="flex-column" style={{ gap: "5px" }}>
                  <div className="h7 bold">
                    {i18n("dropout.notice.rejoin.title")}
                  </div>
                  <div className="h7">{i18n("dropout.notice.rejoin.desc")}</div>
                </div>

                <div className="flex-column" style={{ gap: "5px" }}>
                  <div className="h7 bold">
                    {i18n("dropout.notice.benefitLimit.title")}
                  </div>
                  <div className="h7">
                    {i18n("dropout.notice.benefitLimit.desc")}
                  </div>
                </div>

                <div className="flex-column" style={{ gap: "5px" }}>
                  <div className="h7 bold">
                    {i18n("dropout.notice.idReuse.title")}
                  </div>
                  <div className="h7">
                    {i18n("dropout.notice.idReuse.desc")}
                  </div>
                </div>

                <div className="flex-column" style={{ gap: "5px" }}>
                  <div className="h7 bold">
                    {i18n("dropout.notice.dataDeletion.title")}
                  </div>
                  <div className="h7">
                    {i18n("dropout.notice.dataDeletion.desc")}
                  </div>
                </div>

                <div className="flex-column" style={{ gap: "5px" }}>
                  <div className="h7 bold">
                    {i18n("dropout.notice.posts.title")}
                  </div>
                  <div className="h7">{i18n("dropout.notice.posts.desc")}</div>
                </div>
              </div>

              <label className="login__keep">
                <input
                  type="checkbox"
                  checked={agree}
                  onChange={(e) => setAgree(e.target.checked)}
                />
                <div className="h7 bold">{i18n("dropout.notice.agree")}</div>
              </label>

              <div className="flex-center" style={{ gap: "15px" }}>
                <button
                  onClick={onPrev}
                  disabled={busy}
                  aria-disabled={busy}
                  className="login__btn login__btn--outline"
                >
                  {i18n("common.prev")}
                </button>
                <button
                  onClick={onNext}
                  disabled={!agree || busy}
                  aria-disabled={!agree || busy}
                  className="login__btn login__btn--primary"
                >
                  {i18n("dropout.cta.submit")}
                </button>
              </div>
            </div>
          </>
        );

      default:
        return null;
    }
  }
);

export default function DropoutPage() {
  const { user, loading, refresh } = useAuth();
  const { i18n } = useLang();
  const [userInfo, setUserinfo] = useState({});
  const [step, setStep] = useState(1);
  const [reason, setReason] = useState(null);
  const [customReason, setCustomReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [agree, setAgree] = useState(false);

  useEffect(() => {
    API.getUserInfo(user?.username)
      .then((data) => {
        setUserinfo(data);
      })
      .catch((err) => {
        console.error("getUserInfo API error:", err);
      });
  }, []);

  const handleBack = () => {
    window.location.replace("/my-page");
  };

  const handleNext = () => {
    if (step === 3) {
      doDelete();
    } else {
      setStep(step + 1);
    }
  };

  const handlePrev = () => {
    setStep(step - 1);
  };

  const doDelete = async () => {
    try {
      setBusy(true);
      await API.disableUser(user.username, reason, customReason);
      await signOut();
      await refresh();
    } catch (e) {
      await modal.alert({
        message: e?.message || String(e),
        okText: i18n("common.ok"),
        backdropClose: true,
      });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="my-page">
      <button
        className="topbar__back"
        onClick={handleBack}
        aria-label={i18n("signin.nav.back.aria")}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M15 18l-6-6 6-6"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <div className="topbar__back-text h6">{i18n("signin.nav.back")}</div>
      </button>
      <div className="flex-center" style={{ marginTop: "30px" }}>
        <img
          alt="logo"
          src={require("../img/granhand_logo.png")}
          className="top-logo"
        />
      </div>
      <div className="dropout-body">
        <StepRender
          step={step}
          reason={reason}
          customReason={customReason}
          setCustomReason={setCustomReason}
          setReason={setReason}
          onNext={handleNext}
          onPrev={handlePrev}
          busy={busy}
          userInfo={userInfo}
          agree={agree}
          setAgree={setAgree}
          i18n={i18n}
        />
      </div>
    </div>
  );
}
